<template>
  <div class="note">
    <template v-for="(item, index) in list">
      <div :key="index" class="list">
        <div class="list-time">
          <div class="time-img"></div>
          <span class="time-trig"></span>
          <span class="time">{{item.a_time}}</span>
        </div>
        <div @click="handleDetail(item, index)" class="list-content">
          <h4 :style="item.a_img ? '' : 'margin-bottom: 30px;'">{{item.title}}</h4>
          <img v-if="item.a_img" class="content-img" :src="situationImgUrl + item.a_img" alt="">
          <div style="font-size: 12px;">
            <span>
              <img class="browse" src="../assets/browse.png" alt="">
              <span>{{item.amount}}</span>
            </span>
          </div>
        </div>
      </div>
    </template>
    <div style="text-align: center;">
      <span v-show="list.length > 0 && page < pageCount" style="cursor: pointer;" @click="handleLoad">点击加载更多···</span>
      <span v-show="list.length > 0 && page >= pageCount" style="color: #e78f0b">我是有底线的···</span>
      <span v-show="list.length < 1" style="padding: 200px 0; display: inline-block; font-size: 50px;">暂无数据···</span>
    </div>
    <!-- <el-pagination
      background
      :current-page.sync="page"
      layout="prev, pager, next"
      :total="count"
      @current-change="handleCurrentChange">
    </el-pagination> -->
  </div>
</template>

<script>
  export default {
    name: 'note', //笔记
    metaInfo () {
      return {
        title:'F F 的 Blog'
      }
    },
    data () {
      return {
        list: [],
        // page: Number(sessionStorage.getItem('page')) || 1,
        page: 1,
        count: 0,
        pageCount: 0
      }
    },

    mounted () {
      this.getList(this.page)
    },

    methods: {
      handleDetail (item, index) {
        this.$router.push({
          path: `/detail/${item.id}/note`,
        })
      },

      getList (page) {
        this.$http.get('article/get_article_list', {type: 1, page: page}, true).then(res => {
          if(res.data.code == 0){
            if(page == 1) {
              this.list = res.data.data.products
            } else {
              this.list = this.list.concat(res.data.data.products)
            }
            this.pageCount = res.data.data.pageCount
            this.count = res.data.data.count
            this.page = parseInt(res.data.data.page)
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.$message.error('网络有误！')
        })
      },

      handleLoad () {
        this.getList(this.page + 1)
      },
      
      // handleCurrentChange (page) {
      //   sessionStorage.setItem('page', page)
      //   this.page = page
      //   this.getList(page)
      //   let top = document.documentElement.scrollTop || document.body.scrollTop
      //   // 实现滚动效果 
      //   const timeTop = setInterval(() => {
      //     document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      //     if (top <= 0) {
      //       clearInterval(timeTop)
      //     }
      //   }, 10)
      // },
      
    }
  }
</script>

<style>
  .note {
    box-sizing: border-box;
    border-color: #1575bf;
    margin: 30px 40px 20px 60px;
    border-left: 1px solid #1575bf;
  }

  .note .list {
    margin-bottom: 50px;
  }

  .note .list .list-time {
    display: flex;
    align-items: center;
    position: relative;
    left: -10px;
    top: -10px;
  }

  .note .list .list-time .time-img {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border-radius: 50%;
    border: 1px dashed #1575bf;
    box-sizing: border-box;
    margin-right: 15px;
  }

  .note .list .list-time .time-trig {
    border-right: 16px solid #f7f3ee;
    border-top: 15px dashed transparent;
    border-bottom: 15px dashed transparent;
    width: 0;
    height: 0;
    line-height: 0;
  }

  .note .list .list-time .time {
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    background: #f7f3ee;
    font-size: 10px;
    vertical-align: top;
    line-height: 30px;
  }

  .note .list .list-content {
    margin-bottom: 5px;
    margin: 0px 20px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
  }

  /* .note .list .list-content:hover {
    border: 1px solid #f7f3ee;
  } */

  .note .list .list-content .content-img {
    /* height: 200px; */
    width: 70%;
    margin: 10px 0;
  }

  .note .list .list-content .browse {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 5px;
  }

  .el-pagination {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/note.vue